import Tabs from "./tabs";
import SearchFolderTemplate from "../templates/searchFolder";
import { composeMatchedLines } from "../javascripts/utils.js";
class SearchFolder {
  constructor() {
    this.directory = "";
    this.directoryTitle = "whole theme";
    this._tab = Tabs.addGenericTab("Code search", "code-search");
    this.container = $("#codeSearch-wrapper");
    if (!Tabs.getTab("utilStack")) window.Panes.addUtilStack();
    new SearchFolderTemplate({
      target: document.querySelector("#codeSearch-wrapper"),
      props: {
        directoryTitle: this.directoryTitle,
        fetchFiles: this.fetchFiles,
        onSearchQuery: this.onSearchQuery,
        onReplaceQuery: this.onReplaceQuery
      }
    });
  }

  onSearchQuery = (searchValue, filesJSON, include, strict, isCaseSensitive) => {
    let query = searchValue;
    if (!isCaseSensitive) query = query.toLowerCase();

    filesJSON = filesJSON.flatMap(file => {
      const { raw_body, raw_body_css, raw_body_js, path, secure_random, ...rest } = file;
      if (!/^tephra\//.test(path)) return file;
      return [
        { ...rest, raw_body: raw_body, secure_random: secure_random + "-liquid", path: path + ".liquid" },
        { ...rest, raw_body: raw_body_css, secure_random: secure_random + "-scss", path: path + ".scss" },
        { ...rest, raw_body: raw_body_js, secure_random: secure_random + "-js", path: path + ".js" }
      ];
    });

    let userFilters = include
      .toLowerCase()
      .split(",")
      .map(item => item.trim());

    const filterType = strict ? "every" : "some";
    filesJSON = filesJSON.filter(file => userFilters[filterType](filter => file.path.toLowerCase().includes(filter)));

    const itemInPath = item => item?.path.indexOf(this.directory + "/") > -1;

    const matchedResults = item => {
      let { raw_body } = item;
      if (!isCaseSensitive) raw_body = raw_body?.toLowerCase();
      return itemInPath(item) && raw_body?.includes(query);
    };

    let results = filesJSON.filter(matchedResults).map(result => {
      const { matchedLines } = composeMatchedLines(result.raw_body, query, isCaseSensitive);
      return { ...result, hideCodeSnippet: false, matchedLines };
    });

    let matches = results.map(result => {
      const { lines, matchedLines } = composeMatchedLines(result.raw_body, query, isCaseSensitive);
      return { lines, matchedLines };
    });

    return {
      query,
      items: results,
      relevantFiles: filesJSON.filter(itemInPath),
      length: results.length,
      matches: {
        items: matches,
        length: matches.reduce((accumulator, item) => accumulator + item.matchedLines.length, 0)
      }
    };
  };

  onReplaceQuery = (results, query, replaceWith) => {
    let regX = new RegExp(query.replace(/[!@#$%^&*()+=\-[\]\\';,./{}|":<>?~_]/gi, "\\$&"), "g");
    let _getReference = result => {
      if (result?.path.indexOf("assets/") > -1) return result.reference + "." + result.extension;
      else if (result.reference.split(".").length > 1) return result.reference;
      return result.reference + "." + result.extension;
    };
    return results.items.forEach(result => {
      const isTephra = /^tephra\//.test(result.path);
      if (!result.raw_body || isTephra) return false;
      let new_body = result.raw_body.replace(regX, replaceWith);
      let session = Object.keys(aceSessions).find(session => session.indexOf(result.secure_random) > -1);
      if (session) {
        let new_session_body = aceSessions[session].getValue().replace(regX, replaceWith);
        aceSessions[session].setValue(new_session_body);
      }
      CodeEditor.Main._passiveSave(
        {
          path: result.path,
          reference: _getReference(result),
          file_type: tree.getNodeByKey(result.secure_random).data.file_type,
          content: new_body || "",
          extension: result.extension,
          secure_random: result.secure_random,
          rename: null,
          folder: false
        },
        CodeEditor.UI.notif()
      );
    });
  };

  requestFiles() {
    return $.ajax({
      url: "/api/v1/code_editor/files.json?_ts=" + Date.now(),
      data: { theme_id: CodeEditor.Main.themeId() }
    });
  }

  fetchFiles = async () => {
    let notification = CodeEditor.UI.notif();
    const notificationSettings = {
      id: "folder_search",
      icon: "icon-search",
      message: "<b>Searching...</b>",
      position: "topCenter"
    };
    try {
      notification({ ...notificationSettings, timeout: 100000 });
      let allFiles = await this.requestFiles();
      notification.destroy();
      return allFiles;
    } catch (e) {
      notification.error({
        ...notificationSettings,
        replace: true,
        reset_timeout: true,
        message: "Couldn't load Files!",
        timeout: 2000
      });
    }
  };

  searchInNode(node) {
    console.log(node.children);
  }

  show() {
    if (!Tabs.getTab("code-search")) this.init();
    this.container.show();
  }

  hide() {
    if (Tabs.getTab("code-search")) Tabs.getTab("code-search").close();
  }

  visible() {
    return this.container.is(":visible");
  }

  toggleView() {
    return this.visible() ? this.hide() : this.show();
  }

  attachNode = node => {
    this.node = node;
    this.directoryTitle = node.title;
    if (node.key !== "theme") {
      this.setSearchPath(node.data.path);
    } else {
      this.setSearchPath("");
    }
  };

  setSearchPath = path => {
    if (!path || path.length === 0) {
      this.directory = path;
    } else {
      this.directory = path;
    }
  };
}

export default SearchFolder;
